<template>
  <div class="f">
    <input
      v-model="name"
      class="input-text w-x40 m-rx1"
      placeholder="Player Character"
      @keyup.enter="addPlayer"
    >
    <button class="button bg-onyx white t-10" @click="addPlayer">Add PC</button>
  </div>
</template>

<script setup>
  import { ref } from 'vue';
  import { useCombatEncounterStore } from '../../stores/combat_encounter_store';

  const store = useCombatEncounterStore();

  const name = ref('');

  const addPlayer = () => {
    store.addPlayerToCombatants(name.value);
    name.value = '';
  };
</script>